module.exports = __webpack_public_path__ + "img/Jump Casting123.7b598f3c.jpg";